var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{attrs:{"text":"","small":"","color":"primary"},on:{"click":function($event){return _vm.$emit('compare')}}},[_vm._v(" Compare plans ")]),(_vm.full)?_c('v-btn',{attrs:{"text":"","small":"","color":"primary"},on:{"click":function($event){return _vm.$emit('manage')}}},[_vm._v(" Manage data ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }